const common = require("lib/labels/_common");

// Login

module.exports = {
  member: common.member,
  guest: {
    en: "Guest",
    fr: "Invité"
  },
  form: {
    connect: {
      en: "Connect",
      fr: "Connecter"
    },
    loginError: {
      en: "Invalid login or password",
      fr: "Pseudo ou mot de passe invalide"
    },
    guestError: {
      en: "Invalid pseudo or token",
      fr: "Pseudo ou jeton invalide"
    },
    back: {
      en: "Back",
      fr: "Retour"
    },
    forgotpasswd: {
      en: "Forgotten password",
      fr: "Mot de passe oublié"
    },
    forgotpassword: {
      title: {
        en: "Forgotten password",
        fr: "Mot de passe oublié"
      },
      email: common.email,
      cancel: common.cancel,
      send: common.send
    }
  },
  memberForm: {
    login: {
      en: "Login or Email",
      fr: "Email ou Identifiant"
    },
    password: common.password
  },
  guestForm: {
    pseudo: common.pseudo,
    token: {
      en: "Guest token",
      fr: "Jeton d'invitation"
    }
  }
};
